import { FC } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import type { PicklistEntity } from "../../../functions/picklistValue";
import {
  ProjectIndividual,
  Site,
  SiteContext,
  LinkedItProject,
} from "../canonical";
import ProjectDetailsDashContacts from "./ProjectDetailsDashContacts";
import ProjectDetailsDashSchedule from "./ProjectDetailsDashSchedule";
import ProjectDetailsDashTaskProgress from "./ProjectDetailsDashTaskProgress";

interface ProjectDetailsDashboardProps {
  selectedProject: ProjectIndividual;
  picklist: PicklistEntity[] | undefined;
  /** Which site is rendering - controls display of account info */
  site?: SiteContext;
  contractName?: string | null;
  onContractClick?: () => void;
  linkedItProjects?: LinkedItProject[];
  buildItProjectHref?: (project: LinkedItProject) => string;
}

const ProjectDetailsDashboard: FC<ProjectDetailsDashboardProps> = ({
  selectedProject,
  picklist,
  site = Site.CustomerExperience,
  contractName,
  onContractClick,
  linkedItProjects,
  buildItProjectHref,
}) => {
  if (!selectedProject?.project) return null;
  const allTasks = selectedProject?.tasks ?? [];

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} md={4} sx={{ display: "flex" }}>
        <Paper sx={{ height: "100%", display: "flex", flex: 1, p: 2 }}>
          <Stack sx={{ flex: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" pb={1}>
              SCHEDULE
            </Typography>
            <ProjectDetailsDashSchedule selectedProject={selectedProject} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} sx={{ display: "flex" }}>
        <Paper sx={{ height: "100%", display: "flex", flex: 1, p: 2 }}>
          <Stack sx={{ flex: 1 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ pb: 1 }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                TASK PROGRESS
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {allTasks.length} total
              </Typography>
            </Stack>
            <ProjectDetailsDashTaskProgress
              selectedProject={selectedProject}
              picklist={picklist}
            />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} sx={{ display: "flex" }}>
        <Paper sx={{ height: "100%", display: "flex", flex: 1, p: 2 }}>
          <Stack sx={{ flex: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" pb={1}>
              DETAILS
            </Typography>
            <ProjectDetailsDashContacts
              selectedProject={selectedProject}
              site={site}
              contractName={contractName}
              onContractClick={onContractClick}
              linkedItProjects={linkedItProjects}
              buildItProjectHref={buildItProjectHref}
            />
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ProjectDetailsDashboard;
